<template>
  <div class="nx-url-selector-wrapper">
    <v-autocomplete
        :item-text="'path'"
        :items="computedItems"
        :loading="loading"
        :search-input.sync="searchInput"
        :value="value"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
        @input="inputHandler"
        append-icon="link"
        menu-props="closeOnContentClick"
        no-filter
        v-bind="$attrs"
        chips
    >
      <template slot="selection" slot-scope="{ item: url, selected }">
        <v-chip
            :selected="selected"
            @input="inputHandler(null)"
            close
        >
          <v-avatar>
            <v-icon>link</v-icon>
          </v-avatar>
          {{ url }}
        </v-chip>
      </template>

      <template slot="item" slot-scope="{ item: url }">
        <v-list-tile-avatar>
          <v-icon>link</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ url }}
          </v-list-tile-title>
        </v-list-tile-content>
      </template>

      <template slot="no-data">
        <v-list-tile>
          <v-list-tile-avatar>
            <v-progress-circular
                :width="2"
                indeterminate
                size="28"
                v-if="loading"
            ></v-progress-circular>
            <v-icon v-html="noData.icon" v-else></v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="noData.text"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>

    </v-autocomplete>

  </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import api from '@/modules/url/api';

export default {
  name: 'nx-path-selector',
  props: {
    value: {
      type: String,
      default: null,
    },
    unique: {
      type: Boolean,
      default: true,
    },
    suggestContext: {
      type: Object,
      default: null,
    },
    required: {
      type: Boolean,
    },
  },
  data() {
    return {
      searchInput: '',
      items: [],
      loadingCount: 0,
    };
  },
  computed: {
    loading: {
      get() {
        return this.loadingCount > 0;
      },
      set(value) {
        if (value) {
          this.loadingCount += 1;
        } else {
          this.loadingCount = Math.max(0, this.loadingCount - 1);
        }
      },
    },
    noData() {
      if (this.loading) {
        return {
          icon: 'loading',
          text: this.$t('message.common.loading'),
        };
      }
      if (this.searchInput) {
        return {
          icon: 'not_interested',
          text: this.$t('message.search.noDataFound'),
        };
      }
      return {
        icon: 'edit',
        text: this.$t('message.search.typeToSearch'),
      };
    },
    computedItems() {
      if (this.value) {
        return this.items.concat(this.value);
      }
      return this.items;
    },
    /**
     * Returns a new CancelToken from axios.
     * If there already is an active token, it will be canceled before returning the new one.
     *
     * @return {function(): CancelTokenSource}
     */
    searchTokenSource() {
      let token = null;
      return () => {
        if (token && token.cancel) {
          token.cancel();
        }
        token = axios.CancelToken.source();
        return token;
      };
    },
  },
  methods: {
    inputHandler(value) {
      this.$emit('input', value);
    },
    async performSearch() {
      this.loading = true;

      const response = await api.suggest({ text: this.searchInput, unique: this.unique, context: this.suggestContext }, this.searchTokenSource());
      this.items = response.results;

      this.loading = false;
    },
  },
  watch: {
    // eslint-disable-next-line
    searchInput: debounce(async function () {
      if (this.searchInput) {
        this.performSearch();
      }
    }, 300),
  },
  mounted() {
  },
};
</script>
